export { InsightsUpgradePrompt } from './InsightsUpgradePrompt';



// WEBPACK FOOTER //
// ./src/vp-ui/components/InsightsUpgradePrompt/index.js